import { ReactNode } from 'react';
import styled, { css } from 'styled-components';

interface ListItemProps {
  children?: ReactNode;
  onClick?: any;
}

export const ListItem = styled.li<ListItemProps>`
  text-transform: capitalize;
  border-bottom: ${({ theme }) => `1px solid ${theme.palette.borderColor}`};
  color: ${({ theme }) => theme.palette.neutral.darkest};
  cursor: pointer;
  font-size: 16px;
  font-weight: 300;
  padding: 8px 20px;
  white-space: nowrap;

  :last-child {
    border-bottom: none;
  }

  ${({ theme }) => {
    return css`
      :hover {
        background-color: ${theme.colors.dropdownHover};
        text-decoration: ${theme.fonts.dropdownHover?.textDecoration};
        font-size: ${theme.fonts.dropdownHover?.fontSize};
        font-weight: ${theme.fonts.dropdownHover?.fontWeight};
        font-style: ${theme.fonts.dropdownHover?.fontStyle};
        color: ${theme.fonts.dropdownHover?.color};
        cursor: 'pointer';
      }
    `;
  }}
`;

interface ListProps {
  children?: ReactNode;
  onClick?: any;
}

export const List = styled.ul<ListProps>`
  border: ${({ theme }) => `1px solid ${theme.palette.borderColor}`};
  border-radius: 0;
  padding: 0;
  position: absolute;
  top: 2px;
  left: calc(50% - 8px);
  z-index: 1000;
  min-width: 160px;
  font-size: 12px;
  text-align: left;
  list-style: none;
  background-color: ${({ theme }) => theme.palette.backgrounds.main};
`;

interface WrapperProps {
  children?: ReactNode;
}

export const Wrapper = styled.div<WrapperProps>`
  position: relative;
`;
